import { useTranslation } from 'react-i18next';

export function useToOxfordComma(listOfItems: string[]) {
  const { t } = useTranslation();

  return listOfItems.reduce(
    (a, v, i, arr) => a + (i < arr.length - 1 ? ', ' : t('confirm-remove-modal.and')) + v,
  );
}
